import { Web2PublishMyTemplates } from 'components/Web2Publish/components/MyTemplate';

const ScreenWeb2PublishMyTemplates = () => {
  return <Web2PublishMyTemplates />;
};

export default ScreenWeb2PublishMyTemplates;
